import CustomPhoneInput from "./CustomPhoneInput/SelectMobileNumber";
import { InputField, TextAreaField, VerifyComponent, EmailField } from "./FieldComponent";
import CustomSelectField from "./CustomSelectField/CustomSelectField";

export const fieldDevelop = [
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      type: "text",
      id: "firstName",
      name: "firstName",
      placeholder: "First Name",
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      type: "text",
      id: "lastName",
      name: "lastName",
      placeholder: "Last Name",
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <EmailField attribute={attribute} />,
    attribute: {
      type: "text",
      id: "email",
      name: "email",
      placeholder: "E-mail id",
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <VerifyComponent attribute={attribute} />,
    attribute: {
      type: "text",
      id: "verifyEmailOTP",
      name: "verifyEmailOTP",
      placeholder: "Vefiy",
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <CustomPhoneInput attribute={attribute} />,
    attribute: {
      type: "text",
      id: "mobile",
      name: "mobile",
      placeholder: "Mobile No",
      md: 8,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      type: "text",
      id: "postalCode",
      name: "postalCode",
      placeholder: "Zip/Postal Code",
      md: 4,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      type: "text",
      id: "businessName",
      name: "businessName",
      placeholder: "Business Name",
      md: 12,
    },
  },
  {
    component: ({ attribute, inputField }) => (
      <CustomSelectField attribute={attribute} inputField={inputField} />
    ),
    attribute: {
      type: "select",
      id: "website",
      name: "website",
      placeholder: "Do you have a Website?",
      md: 12,
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    inputField: {
      type: "text",
      placeholder: "Website URL",
      name: "websiteURL",
    },
  },
  {
    component: ({ attribute }) => <TextAreaField attribute={attribute} />,
    attribute: {
      type: "textarea",
      id: "description",
      name: "description",
      placeholder: "Enter Description",
      rows: 2,
      md: 12,
    },
  },
];

export const fieldCourses = [
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "name",
      labelName: "Full Name",
      type: "text",
      id: "name",
      name: "name",
      placeholder: "Full Name",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "email",
      labelName: "Email address",
      type: "email",
      id: "email",
      name: "email",
      placeholder: "E-mail id",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "mobile",
      labelName: "Mobile No",
      type: "number",
      id: "mobile",
      name: "mobile",
      placeholder: "Mobile No",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "higherEducation",
      labelName: "Higher Education",
      type: "text",
      id: "higherEducation",
      name: "higherEducation",
      placeholder: "Higher Education",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "passoutYear",
      labelName: "Passout Year",
      type: "number",
      id: "passoutYear",
      name: "passoutYear",
      placeholder: "Passout Year",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "age",
      labelName: "Age",
      type: "number",
      id: "age",
      name: "age",
      placeholder: "Your Age",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "profession",
      labelName: "Profession",
      type: "select",
      id: "profession",
      name: "profession",
      placeholder: "Select your Profession",

      required: true,
      md: 6,
    },
    option: [
      "Student",
      "Working IT Company",
      "Working Non-IT Company",
      "Recently pass out and Looking for Job",
      "Other",
    ],
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "country",
      labelName: "Country",
      type: "text",
      id: "country",
      name: "country",
      placeholder: "Country",
      required: true,
      md: 6,
    },
  },
  {
    component: ({ attribute }) => <InputField attribute={attribute} />,
    attribute: {
      labelFor: "pincode",
      labelName: "Pin Code",
      type: "number",
      id: "pincode",
      name: "pincode",
      placeholder: "Pincode",
      required: true,
      md: 6,
    },
  },
];
